var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","height":"100%"},style:({backgroundColor: _vm.item.color})},[_c('iframe',{staticStyle:{"border":"0","width":"950px","height":"100%"},attrs:{"src":_vm.item.url,"border":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }